// extracted by mini-css-extract-plugin
export var cardWrapper = "_45-0";